/**
 * API Service for Recipe for Wonder Campaign
 * Essential API endpoints for the Coke with Meals campaign
 */

import httpClient from '../utils/httpClient';

/**
 * Participant API (for Recipe for Wonder campaign)
 */
export const participantAPI = {
  // Submit participant entry
  entry: async (participantData) => {
    return await httpClient.post('/participant/entry', participantData);
  },

  // Get participant profile
  getProfile: async (participantId) => {
    return await httpClient.get(`/participant/${participantId}`);
  },

  // Update participant profile
  updateProfile: async (participantId, participantData) => {
    return await httpClient.put(`/participant/${participantId}`, participantData);
  }
};

export const teamsAPI = {
  list: async () => {
    return await httpClient.get('/participant/teams');
  }
};

export const noticeAPI = {
  // Notice pop-up "Generate Code": an unused product code, limited per device
  generateCode: async ({ fingerprint, deviceId }) => {
    return await httpClient.post('/participant/generate-code', { fingerprint, device_id: deviceId });
  }
};

// Export essential APIs
const API = {
  participant: participantAPI,
  teams: teamsAPI,
  notice: noticeAPI
};

export default API;
